import { Colors } from '@doordash/design-language'
import styled from 'styled-components'

export const StickyBottom = styled.div`
  z-index: 2;
  position: ${(props: {isMobile: boolean}) => props.isMobile ? 'absolute' : 'relative'};
  bottom: 0;
  background-color: ${Colors.PageBackgroundPrimary};
  width: 100%;
`

export default StickyBottom
